"use client";

import { useMemo } from "react";
import styles from "./MileageHeroSideSection.module.scss";
import Text from "@components/atoms/Text";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { PAGE_TYPES } from "@constants/pageTypes";
import { getCarAvailability } from "@utils/carAvailability";

export const MileageHeroSideBlock = ({
  mileageOverview,
  mileageVariants,
  isSellable,
  brandName,
  modelName,
  cityName,
  onModalOpen,
  carAvailability
}: any) => {


  const variantCountMap = useMemo(() => {
    const map = new Map<string, number>();
    mileageVariants?.forEach(({ fuelType, transmission } : any) => {
      const key = `${fuelType.toLowerCase()}-${transmission.toLowerCase()}`;
      map.set(key, (map.get(key) || 0) + 1);
    });
    return map;
  }, [mileageVariants]);

  const getMatchingVariantCount = (fuelType: string, transmission: string) =>
    variantCountMap.get(
      `${fuelType.toLowerCase()}-${transmission.toLowerCase()}`
    ) || 0;

  const getMatchingVariants = (fuelType: string, transmission: string) =>
    mileageVariants?.filter(
      (variant: any) =>
        variant.fuelType.toLowerCase() === fuelType.toLowerCase() &&
        variant.transmission.toLowerCase() === transmission.toLowerCase()
    ) || [];

  const handleModalOpen = async (item: any, option: any, count: any) => {
    const variants = getMatchingVariants(item.type, option.transmission);
    
    if (onModalOpen) {
      onModalOpen(item.type, option.transmission, count, variants);
    }

    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.MILEAGE_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_choose_a_variant",
        section: "Mileage page summary",
        car_availability: carAvailability || getCarAvailability(`${isSellable}`),
        city_name: cityName,
        vehicle_make: brandName,
        vehicle_model: modelName,
      },
    });
  }

  return (
    <div className={styles.mileageBlock}>
      {mileageOverview?.map((item: any, index: any) => {
        const validOptions = item.options.filter(
          (option: any) =>
            getMatchingVariantCount(item.type, option.transmission) > 0
        );

        if (!validOptions.length) return null;

        return (
          <div key={index} className={styles.optionBlock}>
            <Text className={styles.fuelType}>{`${item.type} Mileage`}</Text>
            <div className={styles.optionRow}>
              {validOptions.map((option: any, idx: any) => {
                const count = getMatchingVariantCount(
                  item.type,
                  option.transmission
                );
                return (
                  <div key={idx} className={styles.card}>
                    <div className={styles.cardContent}>
                      <Text className={styles.transmission}>
                        {option.transmission}
                      </Text>
                      <Text className={styles.mileage}>{option.mileage}</Text>
                    </div>
                    <div
                      className={styles.cardFooter}
                      onClick={() => handleModalOpen(item, option, count)}
                    >
                      <Text className={styles.variantCount}>
                        {count}
                        <span className={styles.variantLabel}>variants</span>
                      </Text>
                      <Image
                        src={`${assetLoader()}/icons/Arrow_right.svg`}
                        alt="Arrow_right"
                        width={20}
                        height={20}
                        loading="lazy"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
